import axios from '@/axios'
import API from '@/API'

const PREFIX = 'user'

export default {
  profile() {
    return axios.get(`${API.endpoint}/${PREFIX}/profile`)
  }
}
